function convertToArray(data) {
    if (data === null || data === undefined) return [];
    var keys = Object.keys(data),
        projects = [];
    keys.forEach((key, i) => {
        projects.push({
            ...data[key],
            id: key
        });
    });
    return projects;
}

export default convertToArray;


// WEBPACK FOOTER //
// ./src/utils/convertToArray.js